module.exports = __webpack_public_path__ + "static/media/currency.de9cc85a.svg";